import { css } from '@emotion/react';
import { ButtonProps, Button as SparkButton } from '@spark-web/button';
import { Text } from '@spark-web/text';
import { ThemeProvider } from '@spark-web/theme';
import { forwardRef } from 'react';
import { useOutletContext } from 'react-router';

import { PARTNER_THEME } from '~/constants';
import { OutletContextType } from '~/types/marketplace';

export const Button = forwardRef(({ children, ...buttonProps }: ButtonProps, ref) => {
  // TODO: move partner as a Button prop instead of being derived from the outlet context
  const { partner } = useOutletContext<OutletContextType>();

  const theme = partner && partner in PARTNER_THEME ? PARTNER_THEME[partner] : 'brighte';
  return (
    <ThemeProvider theme="brighte">
      {/* overriding theme causes button text to use the theme's text which causes ui discrepancy. Had to wrap the text in a theme provider to fix this. */}
      {/* @ts-expect-error Spark-web button only accepts icon/string as children so passing JSX element as children will fail in typescript */}
      <SparkButton {...buttonProps} ref={ref}>
        <ThemeProvider theme={theme}>
          <Text
            size="small"
            weight={theme === 'brighte' ? 'semibold' : 'regular'}
            css={css({ alignItems: 'center', display: 'flex' })}
          >
            {children}
          </Text>
        </ThemeProvider>
      </SparkButton>
    </ThemeProvider>
  );
});

Button.displayName = 'BrighteButton';
